module.exports = __webpack_public_path__ + "gb-eng.1b321588a91242132722.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/gb-eng.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/gb-eng.svg
// module chunks = styles